"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const asynchronous_local_storage_1 = require("asynchronous-local-storage");
const set_cookie_parser_1 = __importDefault(require("set-cookie-parser"));
const log_1 = require("../log");
const log = (0, log_1.getLog)(module);
/**
 * A helper class for context cookies.
 */
class ContextCookieHelper {
    static parseContextCookies(cookies) {
        return cookies
            .map(cookie => set_cookie_parser_1.default.parseString(cookie))
            .map(({ name, value }) => {
            return `${name}=${value}`;
        });
    }
    /**
     * Get any existing context cookies and merge them with the existing cookie header.
     */
    static getCookieHeaderValue(headers) {
        if (asynchronous_local_storage_1.als) {
            const contextCookies = asynchronous_local_storage_1.als.get(ContextCookieHelper.KEY);
            const optionsCookies = headers['cookie'];
            const hasContextCookies = (contextCookies === null || contextCookies === void 0 ? void 0 : contextCookies.length) > 0;
            const hasOptionsCookies = (optionsCookies === null || optionsCookies === void 0 ? void 0 : optionsCookies.length) > 0;
            if (hasOptionsCookies && hasContextCookies) {
                const parsedContextCookies = this.parseContextCookies(contextCookies);
                const combinedCookies = [...parsedContextCookies, optionsCookies].join('; ').trim();
                log.trace('Getting combined cookies: %s', combinedCookies);
                return combinedCookies;
            }
            else if (hasOptionsCookies) {
                log.trace('Getting options cookies: %s', optionsCookies);
                return optionsCookies;
            }
            else if (hasContextCookies) {
                const parsedContextCookies = this.parseContextCookies(contextCookies);
                log.trace('Getting context cookies: %s', parsedContextCookies);
                return parsedContextCookies.join('; ').trim();
            }
            else {
                log.trace('No cookies found');
            }
        }
        else {
            return headers['cookie'];
        }
    }
    static findContextCookies(headers) {
        if (headers === null || headers === void 0 ? void 0 : headers.getSetCookie) {
            return headers.getSetCookie();
        }
        else {
            const setCookieValue = headers === null || headers === void 0 ? void 0 : headers.get('set-cookie');
            return (setCookieValue === null || setCookieValue === void 0 ? void 0 : setCookieValue.length) > 0 ? set_cookie_parser_1.default.splitCookiesString(setCookieValue) : [];
        }
    }
    /**
     * Set any cookies on the fetch response into the http context.
     * @param response
     */
    static setContextCookies(response) {
        const cookies = asynchronous_local_storage_1.als.get(ContextCookieHelper.KEY);
        if (cookies == null && response.headers) {
            const contextCookies = this.findContextCookies(response.headers);
            if ((contextCookies === null || contextCookies === void 0 ? void 0 : contextCookies.length) > 0) {
                log.trace('Setting context cookies: %s', contextCookies);
                asynchronous_local_storage_1.als.set(ContextCookieHelper.KEY, contextCookies);
            }
        }
    }
    /**
     * Merge any context cookies with cookies set by Aurora into the 'set-cookie' header on the page response.
     */
    static setResponseCookies(response) {
        const contextHeaders = asynchronous_local_storage_1.als.get(ContextCookieHelper.KEY);
        if ((contextHeaders === null || contextHeaders === void 0 ? void 0 : contextHeaders.length) > 0) {
            const setCookieHeaderValue = response.getHeader('set-cookie');
            let setCookieValues = [];
            if (setCookieHeaderValue) {
                if (Array.isArray(setCookieHeaderValue)) {
                    setCookieValues = [...contextHeaders, ...setCookieHeaderValue];
                }
                else {
                    setCookieValues = [...contextHeaders, `${setCookieHeaderValue}`];
                }
            }
            log.trace('Setting response cookies: %s', setCookieValues);
            if (setCookieValues.length > 0) {
                response.setHeader('set-cookie', setCookieValues);
            }
        }
    }
}
ContextCookieHelper.KEY = 'contextCookies';
exports.default = ContextCookieHelper;
//# sourceMappingURL=ContextCookieHelper.js.map